<template>
  <layout>
    <admin-page-header :header="$t('account.settings')" />
    <div ref="content" class="content">
      <form @submit.prevent="submit">
        <b-row>
          <b-col lg class="user-general-setting">
            <b-card :title="$t('account.general')">
              <fields :form="self" ungrouped />
            </b-card>
          </b-col>

          <b-col lg>
            <b-card :title="$t('account.billing')">
              <fields :form="self" group="billing" />
            </b-card>
          </b-col>

          <b-col lg>
            <b-card :title="$t('account.notifications')">
              <fields :form="self" group="notifications" />
            </b-card>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm>
            <b-card :title="$t('account.password')">
              <fields :form="self" group="password" />
            </b-card>
          </b-col>

          <b-col sm>
            <b-card :title="$t('account.payment')">
              <b-form-group
                v-if="model.card_brand"
                :label="$t('account.credit_card')"
                label-for="credit-card"
                label-cols="4"
              >
                <b-form-input
                  :value="
                    `${model.card_brand}: **** **** **** ${model.card_last_four}`
                  "
                  type="text"
                  class="form-control-plaintext"
                />
              </b-form-group>
              <div v-else>{{ $t('account.no_payment_info') }}</div>
            </b-card>
          </b-col>
        </b-row>

        <div class="form-group">
          <b-button type="submit" variant="primary">
            {{ $t('general.save') }}
          </b-button>
          <b-button
            v-if="showCancelButton"
            type="button"
            variant="light"
            class="ml-2"
            @click="cancel"
          >
            {{ $t('general.cancel') }}
          </b-button>
        </div>
      </form>
    </div>
  </layout>
</template>

<script>
import { AdminPageHeader } from 'stylemix-vue-admin'
import { ResourceFormMixin } from 'stylemix-vue-admin'

export default {
  name: 'UsersForm',

  components: {
    AdminPageHeader,
  },

  mixins: [ResourceFormMixin],

  props: {
    showCancelButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      model: {},
      base: 'users',
      self: this,
    }
  },

  mounted() {
    this.loadForm()
  },

  methods: {
    loadForm() {
      let promise = this.$http.get('account/profile')
      this.$uiBlocker(promise, document.getElementById('content'))
      promise.then(result => {
        this.model = result.data.data
        this.setFields(result.data.fields)

        this.setFieldGroup('billing', [
          'settings.billing_company',
          'settings.billing_vat',
          'settings.billing_address',
          'settings.billing_city',
          'settings.billing_country',
          'settings.billing_zip',
          'settings.billing_email',
        ])

        this.setFieldGroup('password', ['password'])

        return result
      })
    },
    submit() {
      let formData = this.formData(this.model)
      formData.append('_method', 'put')
      let promise = this.$http.post('account/profile', formData)
      this.$uiBlocker(promise, this.$refs.content)
      promise.then((/*response*/) => {
        this.$toast.success(this.$t('account.messages.updated'))
      })
    },
  },
}
</script>
